import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthProvider, AuthContext } from './context/AuthContext';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AccountPage from './pages/AccountPage';
import EmailVerifyPage from './pages/EmailVerifyPage';
import AdRedirectPage from './pages/AdRedirectPage';
import SettingsPage from './pages/SettingPage';
import UpgradePage from './pages/UpgradePage';
// import ProtectedPremium from './pages/ProtectedPremium';
import PaymentSuccess from './pages/PaymentSuccess';
import LandingPage from './pages/LandingPage';
import MyLinks from './pages/MyLinks';
import PublicAnalytics from './components/Analytics/PublicAnalytics';
import ForgotPage from './pages/auth/ForgotPage';
import ResetPage from './pages/auth/ResetPage';
import QrCodesPage from './pages/QrCode/QrCodesPage';
import CustomDomainsPage from './pages/domain/CustomDomainsPage';
import AnalyticsP from './pages/features/AnalyticsD';
import CreateQrCodePage from './pages/QrCode/CreateQrCodePage';
import UrlExpirySettings from './pages/Urls/UrlExpirySettings';
import AddDomainPage from './pages/domain/AddDomainPage';
import EditLinkPage from './pages/EditLinkPage';
import ComingSoon from './pages/dev/ComingSoon';
import AdminComingSoon from './pages/dev/AdminComingSoon';
import NotFound from './pages/dev/NotFound';
import AboutPage from './pages/comPage/AboutPage';
import PrivacyPolicyPage from './pages/comPage/PrivacyPolicyPage';
import TermsOfServicePage from './pages/comPage/TermsOfServicePage';
import ContactPage from './pages/comPage/ContactPage';
import UtmBuilderPage from './pages/features/UtmBuilderPage';
import CampaignTagsPage from './pages/features/CampaignTagsPage';
import AdminUsersPage from './components/admin/AdminUsersPage';
import AdminRoute  from './context/RoleRoute';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import RefundPolicyPage from './pages/comPage/RefundPolicyPage';
import TrafficLimitPage from './pages/dev/TrafficLimitPage';
import UpgradeRequiredPage from './pages/dev/UpgradeRequiredPage';
import UrlShortenerPage from './pages/products/UrlShortenerPage';
import QrCodesPages from './pages/products/QrCodesPages';
import AnalyticsPages from './pages/products/AnalyticsPages';
import ProductsPage from './pages/products/image/ProductPage';
import PricingPage from './pages/products/PricingPage';
import AffiliatePage from './pages/affiliate/affiliatePage';
import AffiliateRegister from './pages/affiliate/AffiliateRegister';
import BlogList from './pages/blog/BlogList';
import BlogPost from './pages/blog/BlogPost';
import CreateBlog from './pages/admin/CreateBlog';
import AdminBlogs from './pages/admin/AdminBlogs';
import BlogEditor from './components/blog/BlogEditor';

// Proper PrivateRoute using useContext
function PrivateRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <p>Loading...</p>; // <-- wait until auth is ready
  return user ? children : <Navigate to="/login" replace />;
}


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
         
          <Route path="/" element={<LandingPage />} />
          <Route path="/u2lr-products" element={<ProductsPage />} />
          <Route path="/u2lr-pricing" element={<PricingPage />} />
          <Route path="/our-products/url-shortener" element={<UrlShortenerPage />} />
          <Route path="/our-products/qr-codes" element={<QrCodesPages />} />
          <Route path="/our-products/analytics" element={<AnalyticsPages />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/limit-reached" element={<TrafficLimitPage />} />
          <Route path="/upgrade-required" element={<UpgradeRequiredPage />} />

          <Route path="/user-dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />

          {/* URLs  */}
          <Route path="/dashboard/urls" element={<MyLinks />} />
          <Route path="/dashboard/urls/:id" element={<EditLinkPage />} />
          <Route path="/dashboard/urls-expiry" element={<UrlExpirySettings />} />
          <Route path="/s/:shortCode" element={<AdRedirectPage />} />
         
         
          {/* Affiliate route */}
          <Route path="/affiliate/register" element={<AffiliateRegister />} />
          <Route path="/affiliate/dashboard" element={<AffiliatePage />} />

          {/* Blogs route */}
          <Route path="/blog/all-article" element={<BlogList />} />
          <Route path="/blog/article/:slug" element={<BlogPost />} />


          {/* Analytics */}
          <Route path="/analytics/:code" element={<AnalyticsPage />} />
          <Route path="/dashboard/analytics" element={<AnalyticsP />} />
          <Route path="/link/p/:code/stats" element={<PublicAnalytics />} />


          <Route path="/account" element={<AccountPage />} />
          <Route path="/account/upgrade" element={<UpgradePage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/account/settings" element={<SettingsPage />} />
          <Route path="*" element={<NotFound />} />

          {/*QR Features */}
          <Route path="/qrcodes/dynamic" element={<QrCodesPage />} />
          <Route path="/qr-codes/create" element={<CreateQrCodePage />} />
          <Route path="/qrcodes/templates" element={<ComingSoon />} />
          <Route path="/qrcodes/instant" element={<ComingSoon />} />


          {/* co-features */}
          <Route path="/campaigns-tags" element={<CampaignTagsPage />} />
          <Route path="/utm-builder" element={<UtmBuilderPage />} />
          <Route path="/api-keys" element={<ComingSoon />} />
          <Route path="/bulk-links" element={<ComingSoon />} />
          <Route path="/dashboard/details-analytics" element={<ComingSoon />} />
          <Route path="/dashboard/custom-report" element={<ComingSoon />} />


          {/* Domain */}
          <Route path="/dashboard/custom-domains" element={<CustomDomainsPage />} />
          <Route path="/dashboard/custom-domains/add" element={<AddDomainPage />} />

          {/* Auth route */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPage />} />
          <Route path="/reset-password" element={<ResetPage />} />
          <Route path="/verify-email" element={<EmailVerifyPage />} />

          {/* Admin route */}
          <Route
            path="/admin/users"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <AdminUsersPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <AdminDashboardPage />
              </AdminRoute>
            }
          />
                    
          <Route
            path="/admin/qrcodes"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <AdminComingSoon />
              </AdminRoute>
            }
          />          
          <Route
            path="/admin/settings"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <AdminComingSoon />
              </AdminRoute>
            }
          />          
          <Route
            path="/admin/links"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <AdminComingSoon />
              </AdminRoute>
            }
          />  
                    <Route
            path="/admin/blog/create"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <CreateBlog />
              </AdminRoute>
            }
          />    
          <Route
            path="/admin/blogs"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <AdminBlogs />
              </AdminRoute>
            }
          />
                    <Route
            path="/admin/blog/edit/:id"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <BlogEditor />
              </AdminRoute>
            }
          />              
          <Route
            path="/admin/subscriptions"
            element={
              <AdminRoute allowedRoles={['admin', 'super_admin']}>
                <AdminComingSoon />
              </AdminRoute>
            }
          />

          {/* Super admin-only page */}
          <Route
            path="/super-dashboard"
            element={
              <AdminRoute allowedRoles={['super_admin']}>
                {/* <SuperAdminDashboard /> */}
              </AdminRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;